/**
 * A phrase the server sends, set as a sentence on a screen: **a capital first letter and ONE full stop.** An acronym-led or an
 * already-capitalised phrase is left as it is (its first letter is already a capital), and a phrase that ends on a mark keeps
 * it, so there is never a double full stop. One helper for every caller (`D2`, `D3`): the words stay the server's.
 */
export const asSentence = (phrase: string): string => {
  const text = phrase.trim();
  if (text === "") return "";
  const first = text.charAt(0);
  const capital =
    first === first.toLocaleUpperCase("fr") ? text : `${first.toLocaleUpperCase("fr")}${text.slice(1)}`;
  return /[.!?…]$/u.test(capital) ? capital : `${capital}.`;
};
